'use client';
import OrderDetailsPage from '@c/dashboard/pages/OrderDetailsPage';
import { useQuery } from '@tanstack/react-query';
import { getOrderById } from '@util/firestore/orders';
import { useAuth } from 'context/AuthContext';
import { usePathname, useRouter } from 'next/navigation';

const PurchaseDetails = () => {
  const pathname = usePathname();
  const order_id = pathname?.split('/').pop();
  const { userDoc } = useAuth();
  const router = useRouter();
  const { data: order } = useQuery({
    queryKey: ['order', order_id],
    queryFn: () => getOrderById(order_id as string),
    enabled: !!order_id,
  });
  if (!order_id) return null;
  const variant: 'buyer' | 'seller' =
    userDoc?.roles?.admin || userDoc?.uid === order?.buyer_id
      ? 'buyer'
      : 'seller';
  if (!userDoc) return null;
  if (variant === 'seller') {
    router.replace(`/dashboard/orders/${order_id}`);
    return null;
  }
  return <OrderDetailsPage order_id={order_id} variant={variant} />;
};

export default PurchaseDetails;
